/// <reference path="DOMAttached.js" />

class GNOMStatBox extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.linkEl = this.el.querySelector('a');

		if (this.linkEl != undefined && this.options.link != undefined)
			this.safeObserve(this.linkEl, 'click', this.onClick.bind(this));
	}

	onClick(ev) {
		this.el.closest('.tabbedApplication').attachedObj.findAndLoadTab(this.options.link);
		ev.preventDefault();
		ev.stopPropagation();
	}
}
